<span class="label" id="ciclo">{{ label }}</span>
<p-select
	ariaLabelledBy="ciclo"
	[formControl]="control"
	[options]="(options$ | async) || []"
	data-cy="ciclo"
	[showClear]="true"
	[filter]="filter"
	filterBy="numero,dataInicioCiclo,dataFimCiclo"
	[placeholder]="placeholder"
	(onChange)="changed.emit($event.value)"
	(onClear)="changed.emit(undefined)"
	emptyMessage="Nenhum Ciclo encontrado"
	emptyFilterMessage="Nenhum Ciclo encontrado"
>
	<ng-template #selectedItem>
		@if (control.value; as ciclo) {
		<span>{{ciclo.numero}}</span>&nbsp;-&nbsp;<span>{{ciclo.dataInicioCiclo}}</span>&nbsp;-&nbsp;
		<span>{{ciclo.dataFimCiclo}}</span>
		}
	</ng-template>
	<ng-template #item let-ciclo>
		<div class="ciclo-item">
			<span>{{ciclo.numero}}</span> - <span>{{ciclo.dataInicioCiclo}}</span> -
			<span>{{ciclo.dataFimCiclo}}</span>
		</div>
	</ng-template>
</p-select>
<sgp-message-feedback mensagem="O campo é obrigatório" data-cy="erro-ciclo-obrigatorio" [show]="showError" />
